import type { AluminiumAISampleComposition, PETComposition } from 'api';
import { useTranslation } from 'i18n';
import { Link } from 'react-router-dom';
import { DataCard, formatNumber } from 'ui';
import { Insights } from 'ui/icons';
import { AiSampleBreakdown } from '../../../breakdowns';
import { AdminAiVersionTitle } from '../../../breakdowns/components/AdminAiVersionTitle/AdminAiVersionTitle';
import { AiLooseModels } from '../../../evidence';

export const TradeCompanySessionLooseDataCard = ({
  isLoading = false,
  totalWeight,
  composition,
  aiModel,
  sessionLink,
  sessionName,
  latestRunAIVersion,
}: {
  isLoading?: boolean;
  totalWeight?: number;
  composition?: PETComposition | AluminiumAISampleComposition;
  aiModel?: AiLooseModels;
  sessionLink?: string;
  sessionName?: string;
  latestRunAIVersion?: string;
}) => {
  const { t } = useTranslation('features');
  return (
    <DataCard
      dataTestId="trade-company-session-loose-data-card"
      isLoading={isLoading}
      slotProps={{
        header: {
          avatar: <Insights data-testid="InsightsIcon" />,
          title: (
            <AdminAiVersionTitle
              title={t('dataCards.tradeCompanySessionLoose.aiLooseAnalysisTitle')}
              version={latestRunAIVersion}
            />
          ),
        },
      }}
    >
      {sessionLink && sessionName ? (
        <DataCard.Item title={t('dataCards.tradeCompanySessionLoose.reportTitle')} colSpan={6}>
          <Link to={sessionLink}>{sessionName}</Link>
        </DataCard.Item>
      ) : null}
      {totalWeight ? (
        <DataCard.Item
          title={t('dataCards.tradeCompanySessionLoose.sampleTotalWeightTitle')}
          colSpan={6}
          data-testid="total-weight"
        >
          {formatNumber(totalWeight, { maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'kilogram' })}
        </DataCard.Item>
      ) : null}
      <DataCard.Item colSpan={12}>
        <AiSampleBreakdown totalWeight={totalWeight} model={aiModel} composition={composition} />
      </DataCard.Item>
    </DataCard>
  );
};
